/* eslint-disable no-param-reassign */
import reduce from 'lodash/reduce';
import forEach from 'lodash/forEach';

import defer from 'lodash/defer';

import store from './store';

const CACHES = {};
let CONFIG = {};

const set = (() => {
  let hasSetConfig = false;
  return (config) => {
    if (!hasSetConfig) {
      hasSetConfig = true;
      CONFIG = config;
    }
  };
})();

export const setConfig = set;

export function getConfig() {
  return CONFIG;
}

export function getCacheItem(cacheKey) {
  return CACHES[cacheKey];
}

export function setCacheItem(key, cache) {
  CACHES[key] = cache;
}

export function resetCache() {
  forEach(CACHES, (_, cacheKey) => {
    delete CACHES[cacheKey];
  });
}

export function getReducers() {
  return reduce(
    CACHES,
    (result, cache, cacheKey) => {
      result[cacheKey] = cache.reducer;
      return result;
    },
    {
      lastAction: (state, action) => action,
    },
  );
}

const reset = ({ cacheKey }) => {
  const connectedCache = getCacheItem(cacheKey);
  connectedCache.isStale = true;
  connectedCache.isReady = false;
  store.dispatch({ type: `${cacheKey}:RESET` });

  return new Promise((resolve) => {
    defer(() => {
      resolve();
    });
  });
};

export function resetCacheItem(cacheKey) {
  reset({ cacheKey });
}
